module.exports = __webpack_public_path__ + "img/happy-cheerful-business-people.6eb7882f.png";